export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["initial"] = "INITIAL";
    ActionTypes["setProps"] = "SET_PROPS";
    ActionTypes["clearProps"] = "CLEAR_PROPS";
})(ActionTypes || (ActionTypes = {}));
